import { REPORT_STATUSES } from '../Timeline/Timeline.helpers';
import moment from 'moment';

export const singleTurbineData = [
    {
        key: 'TURBINE STATUS',
        type: REPORT_STATUSES.STOPPED,
        description: REPORT_STATUSES.STOPPED,
        beginDate: moment('2018-01-13T01:00:00.000+0000'),
        endDate: moment('2018-01-13T09:00:00.000+0000'),
    },
    {
        key: 'TURBINE STATUS',
        type: REPORT_STATUSES.STOPPED,
        description: REPORT_STATUSES.STOPPED,
        beginDate: moment('2018-01-13T06:00:00.000+0000'),
        endDate: moment('2018-01-13T09:59:00.000+0000'),
    },
    {
        key: 'TURBINE STATUS',
        type: REPORT_STATUSES.STOPPED,
        description: REPORT_STATUSES.STOPPED,
        beginDate: moment('2018-01-13T12:00:00.000+0000'),
        endDate: moment('2018-01-13T14:30:00.000+0000'),
    },
    {
        key: 'NOTES',
        type: REPORT_STATUSES.DURATION,
        description: 'Black start link applied - Paul Duffy 19/10/2017',
        beginDate: moment('2018-01-13T01:00:00.000+0000'),
        endDate: moment('2018-01-13T02:59:00.000+0000'),
    },
    {
        key: 'NOTES',
        type: REPORT_STATUSES.DURATION,
        description: 'Front door Siemens lock key has snapped inside the lock.',
        beginDate: moment('2018-01-13T03:00:00.000+0000'),
        endDate: moment('2018-01-13T04:59:00.000+0000'),
    },
    {
        key: 'EXCEPTIONS',
        type: REPORT_STATUSES.DURATION,
        description: 'Exception 1',
        beginDate: moment('2018-01-13T07:00:00.000+0000'),
        endDate: moment('2018-01-13T09:59:00.000+0000'),
    },
    {
        key: 'EXCEPTIONS',
        type: REPORT_STATUSES.DURATION,
        description: 'Exception 2',
        beginDate: moment('2018-01-13T08:00:00.000+0000'),
        endDate: moment('2018-01-13T09:59:00.000+0000'),
    },
    {
        key: 'RESTRICTIONS',
        type: REPORT_STATUSES.DURATION,
        description: 'Restriction',
        beginDate: '2018-01-13T01:00:00.000+0000',
        endDate: '2018-01-13T10:59:00.000+0000',
    },
];
